import React from 'react';
import './index.css';
import List from './list.js';
import Export from './export.js';
import { Route } from 'react-router-dom';

class Content extends React.Component {
  constructor(){
    super();
    this.state = {
      typeList : false
    }
  }
  render(){
    const { parent, menu } = this.props;
    let done = true;
    return (
      <div id="manageMain" className="content-main">
        {  (parent === menu) && done ?
          <Route path={ window.path } component={ List } /> :<Route path={ window.path } component={ Export } />
        }
      </div>
    )
  }
}
export default Content;



// WEBPACK FOOTER //
// ./src/component/record/content.js